<script lang="ts">
	interface Props {
		title?: string | null;
		clr?: string;
	}

	let { title = 'Drag', clr = 'hsl(var(--clr-on-surface-1))' }: Props = $props();
</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon" style:--clr={clr}>
	{#if title}
		<title>{title}</title>
	{/if}
	<path d="M11 21H9V3H11V21M15 3H13V21H15V3Z" />
</svg>

<style lang="scss">
	.icon {
		width: 1rem;
		fill: var(--clr);
	}
</style>
